/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyStatusItemDto
 */
export interface PropertyStatusItemDto {
    /**
     * 
     * @type {string}
     * @memberof PropertyStatusItemDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyStatusItemDto
     */
    label: string;
}

/**
 * Check if a given object implements the PropertyStatusItemDto interface.
 */
export function instanceOfPropertyStatusItemDto(value: object): value is PropertyStatusItemDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function PropertyStatusItemDtoFromJSON(json: any): PropertyStatusItemDto {
    return PropertyStatusItemDtoFromJSONTyped(json, false);
}

export function PropertyStatusItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyStatusItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
    };
}

export function PropertyStatusItemDtoToJSON(json: any): PropertyStatusItemDto {
    return PropertyStatusItemDtoToJSONTyped(json, false);
}

export function PropertyStatusItemDtoToJSONTyped(value?: PropertyStatusItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

